export const environment = {
  production: false,
  API_URL: "https://dapi.mytag.ae/api/v1",
  WEB_URL: "https://dapp.mytag.ae/",
  appVersion: 'v726demo1',
  AUTHDATA_KEY: 'authf649fc9a5f55',
  USERDATA_KEY: 'userf649fc9a5f55',
  MENUDATA_KEY: 'menuf649fc9a5f55',
  USER_DEFAULT_PIC: './assets/media/users/default.jpg',
  USER_DEFAULT_PIC_150: './assets/media/users/default_150x150.png',
  COMPANY_DEFAULT_PIC: './assets/media/company/default.png',
  DPWORLD_DEFAULT_HEADER: './assets/dpworld_default.png',
  DEFAULT_COLOR: '#000000',
  STORAGE_TYPE: 1,  // 1- Cookies, 2 - LocalStorage, 3 - SessionStorage
  MAILREGEX: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  CAPTCHA_KEY:'6LegqHEnAAAAAKvS6Y3AoL9ifMnBhw6Hq0DnLwf9',
  INVALID_CUST_URL:['home','auth','product','user'],
  enableGtm: true
};
